export enum QuestionnaireType {
  individual = 'INDIVIDUAL',
  family = 'FAMILY'
}